export const TYPE = {
  MATCH: 'match',
  GROUP: 'group',
  SORT: 'sort',
};

export const TYPE_TITLE = {
  [TYPE.MATCH]: 'Match',
  [TYPE.GROUP]: 'Group by',
  [TYPE.SORT]: 'Sort',
};
